module.exports = __webpack_public_path__ + "media/images/sp/stores/omiya/omiya_sns_02-23f9bbd871923a0d7ec52240e0d2813a.jpg";